import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Table,
  Col,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
// import DefaultImg from "../../../assets/images/product/Default_img.jpg";

import { ExportToExcel } from "../../Common/ExportToExcel";
import { getMRreportslist } from "../../../store/Reports/actions";
import "../reports.scss";
var date = new Date(),
  y = date.getFullYear(),
  m = date.getMonth();
class MRReportList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getMRreportslist({
      ...this.props.params,
      start_date:
        this.props.params.start_date == null ||
        this.props.params.start_date === ""
          ? moment(new Date(y, m, 1)).format("YYYY-MM-DD")
          : this.props.params.start_date,
      end_date:
        this.props.params.end_date == null || this.props.params.end_date === ""
          ? moment(new Date()).add(1, "days").format("YYYY-MM-DD")
          : moment(this.props.params.end_date)
              .add(1, "days")
              .format("YYYY-MM-DD"),
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col md={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom no-print">
                    <Link
                      to="/mrreport"
                      className="action-icon text-primary mr-2"
                    >
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                    </Link>
                    <div className="float-right">
                      <div className="d-inline-block ">
                        <ExportToExcel
                          apiData={(this.props.MR_ReportData || []).map(
                            (mr) => ({
                              "MR Code": mr?.code || "-",

                              Location: mr?.location?.name || "-",

                              "Sub Location": mr?.sublocation?.name || "-",

                              "User Department":
                                mr?.userdepartment?.name || "-",

                              "Requested On": mr?.date
                                ? moment(mr.date).format("DD-MM-YYYY")
                                : "-",

                              "Submited On": mr?.createdon
                                ? moment(mr.createdon).format("DD-MM-YYYY")
                                : "-",

                              Status: mr?.mrstatus_name || "-",

                              "Created By": mr?.createdby
                                ? `${mr.createdby.fullname} (${mr.createdby.username})`
                                : "-",
                            })
                          )}
                          topHeader={[
                            "SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD",
                            "Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist. - AP",
                            "Phone No.0884-2326661, 62, Mobile No.9494127893, Email: purchase@sleipl.com, lalitharice@gmail.com",
                            "",
                            "MATERIAL REQUEST REPORT",
                            "",
                          ]}
                          fileName="MATERIAL_REQUEST_REPORT"
                        />

                        {/* <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" mr-2"
                          onClick={() => this.getExcelReport()}
                        >
                          <i className="ri-file-excel-2-line"></i>
                          <span className="d-none d-inline-block ml-1">
                            Excel
                          </span>
                        </Button> */}
                        {/* <ReactHTMLTableToExcel
                          id="test-table-xls-button"
                          className=" mr-2"
                          // className="download-table-xls-button"
                          table="table-to-xls"
                          filename="tablexls"
                          sheet="tablexls"
                          buttonText="Excel"
                        /> */}
                        <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" ml-2"
                          onClick={() => window.print()}
                        >
                          <i className="mdi  mdi-printer"></i>
                          <span className="d-none d-inline-block ml-1">
                            Print
                          </span>
                        </Button>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-2">
                    <div className="text-center">
                      <span className="display_none printme">
                        <h5 className="card-title-18 pt-2 ">
                          SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD
                        </h5>
                        <p className="card-title-14 pt-2 mb-0">
                          Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist.
                          - AP
                        </p>
                        <p className="card-title-14 pt-2">
                          Phone No.0884-2326661, 62, Mobile No.9494127893,
                          Email: purchase@sleipl.com, lalitharice@gmail.com
                        </p>
                        <hr />
                      </span>
                      <h5 className="card-title-16 pt-3 ">
                        MATERIAL REQUEST REPORT ({" "}
                        {this.props.params.start_date == null ||
                        this.props.params.start_date === ""
                          ? moment(new Date(y, m, 1)).format("DD-MM-YYYY")
                          : moment(this.props.params.start_date).format(
                              "DD-MM-YYYY"
                            )}{" "}
                        TO{" "}
                        {moment(this.props.params.end_date).format(
                          "DD-MM-YYYY"
                        )}{" "}
                        )
                      </h5>
                    </div>
                    {/* <div className="Filter-panel-content">
                      <div className="list-column">
                        <Row>
                          <Col md={4}>
                            <ul className="list-style p-0">
                              <li className="clearfix">
                                <span className="ttl">From Date: </span>
                                <span className="dtl">
                                  {this.props.params.start_date}
                                </span>
                              </li>
                              <li className="clearfix">
                                <span className="ttl">To Date:</span>
                                <span className="dtl">
                                  {this.props.params.end_date}
                                </span>
                              </li>
                            </ul>
                          </Col>
                          <Col md={4}>
                            <ul className="list-style p-0">
                              <li className="clearfix">
                                <span className="ttl">Locations: </span>
                                <span className="dtl">
                                  {this.props.params.start_date}
                                </span>
                              </li>
                              <li className="clearfix">
                                <span className="ttl">Sub Location:</span>
                                <span className="dtl">
                                  {this.props.PIreqRowData?.userdepartment.name}
                                </span>
                              </li>
                            </ul>
                          </Col>
                          <Col md={4}>
                            <ul className="list-style p-0">
                              <li className="clearfix">
                                <span className="ttl">User Department:</span>
                                <span className="dtl">
                                  {this.props.params.end_date}
                                </span>
                              </li>
                            </ul>
                          </Col>
                        </Row>
                      </div>
                    </div> */}
                    {/* <div>
                      <Row>
                        <Col md={6}>
                          <span>From Date:</span>
                          <span>
                            {this.props.params.start_date == null
                              ? "all"
                              : this.props.params.start_date}
                          </span>
                        </Col>
                        <Col md={6}></Col>
                      </Row>
                    </div> */}

                    <div className="table-responsive m-0">
                      <Table
                        bordered
                        hover
                        className="mb-0 p-0 table-centered"
                        id="table-to-xls"
                      >
                        <thead className="bg-light text-center">
                          <tr className="bg-light">
                            <th className="nowrap">
                              <b>MR Code</b>
                            </th>
                            <th className="nowrap">
                              <b>Location</b>
                            </th>
                            <th className="nowrap">
                              <b>Sub Location</b>
                            </th>
                            <th className="nowrap">
                              <b>User Department</b>
                            </th>
                            <th className="nowrap">
                              <b>Requested On</b>
                            </th>
                            <th className="nowrap">
                              <b>Submited On</b>
                            </th>
                            <th className="nowrap">
                              <b>MR Status</b>
                            </th>
                            <th className="nowrap">
                              <b>MI Status</b>
                            </th>{" "}
                            <th className="nowrap">
                              <b>PI Status</b>
                            </th>
                            <th className="nowrap">
                              <b>Created By</b>
                            </th>
                          </tr>
                        </thead>
                        <tbody className="nowrap">
                          {this.props.MR_ReportData?.length ? (
                            <>
                              {this.props.MR_ReportData.map((Material, key) => (
                                <>
                                  <tr key={key} className="text-center">
                                    <td>{Material.code}</td>
                                    <td>{Material?.location?.name}</td>
                                    <td>{Material?.sublocation?.name}</td>
                                    <td>{Material?.userdepartment?.name}</td>

                                    <td>
                                      {Material?.date
                                        ? moment(Material.date).format(
                                            "DD-MM-YYYY"
                                          )
                                        : "-"}
                                    </td>

                                    <td>
                                      {moment(Material?.createdon).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </td>
                                    <td>{Material?.mrstatus_name}</td>
                                    <td>{Material?.mistatus_name}</td>
                                    <td>{Material?.pistatus_name}</td>

                                    <td>
                                      {Material?.createdby
                                        ? `${Material.createdby.fullname} (${Material.createdby.username})`
                                        : "-"}
                                    </td>
                                  </tr>
                                </>
                              ))}
                            </>
                          ) : (
                            <tr>
                              <td colspan="7" className="text-center">
                                <span className="font-size-18 text-danger">
                                  Data not available
                                </span>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { params, reportType, Reportdata, MR_ReportData } = state.reports;
  return {
    params,
    reportType,
    Reportdata,
    MR_ReportData,
  };
};

export default connect(mapStatetoProps, {
  getMRreportslist,
})(MRReportList);
